// extracted by mini-css-extract-plugin
export default {"page":"LoginPage_page__jfiVs","loginText":"LoginPage_loginText__3PIQH","signInButton":"LoginPage_signInButton__qBPjg"};